import { Typography } from "../Typography";
import type { TypographyProps } from "../Typography/Typography.types";

export const RadioHelperText = ({ children, ...props }: Omit<TypographyProps<"p">, "variant">) => (
  <Typography
    native={{
      "data-radio-helper_text": true,
    }}
    variant="body-small"
    {...props}
  >
    {children}
  </Typography>
);
